import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Style/Nav.css';
import BtnCoustom from '../Components/ButtonCstoum';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Set "loaded" to true after component mounts
    setTimeout(() => {
      setLoaded(true);
    }, 100); // small delay for smoother animation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg fixed-top 
      ${scrolled ? 'navbar-colored' : 'navbar-transparent'} 
      ${loaded ? 'navbar-loaded' : ''}`}>
      
      <div className="container">
        <Link className="navbar-brand p-0 m-0 fw-bold fs-2" to="/">RB-Web</Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

          <div className="collapse navbar-collapse navbar-collapse-custom" id="navbarNav">
          <ul className="navbar-nav ms-auto fw-bold">
            <li className="nav-item pe-3">
              <NavLink to="/" className="nav-link">Features & Pricing</NavLink>
            </li>
            <li className="nav-item pe-3">
              <NavLink to="/Gift" className="nav-link">Gift Riley</NavLink>
            </li>
            <li className="nav-item pe-3">
              <NavLink to="/Contact" className="nav-link">Contact</NavLink>
            </li>
            <li className="nav-item pe-3">
              <NavLink to="/News" className="nav-link">What's New?</NavLink>
            </li>
          </ul>
          <BtnCoustom />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
